import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.appPage.DOC}
  mutation AddPages(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $input: [AppPageInput!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          addPages(pages: $input) {
            ...FragmentAppPage
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.AddPagesMutation,
    readonly ents.core.admin.App.Page[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'addPages',
          graphql.transformers.OUT.list(fragments.appPage.TRANSFORMER, {
            onNullish: 'remove',
          }),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.AddPagesMutation,
  readonly ents.core.admin.App.Page[],
  graphql.schema.AddPagesMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
